<template>
    <div :class="inputClass">
        <div>
            <input
                :id="_uid"
                :checked="value"
                :data-checked="value"
                :autofocus="hasAutofocus"
                :required="isRequired"
                type="checkbox"
                @change="change(!value)"
            />
            <label :class="containerClass" :for="_uid">
                <div :class="switchClass"></div>
                <div>
                    <slot name="label">
                        {{ label }}
                    </slot>
                </div>
                <div :class="inlineIconClass">
                    <slot name="inlineIcon"></slot>
                </div>
                <div v-if="shouldShowInfoTooltip" class="form-input-switch__switch--info-tool-tip-main">
                    <div class="form-input-switch__switch--info-tool-tip-arrow"></div>
                    <slot name="infoTooltip"></slot>
                </div>
            </label>
        </div>
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            label: { type: String, default: undefined },
            value: { type: Boolean, default: false },
            isLabelOnLeft: { type: Boolean, default: false },
            spacing: { type: String, default: 'small' },
            shouldShowInfoTooltip: { type: Boolean, default: false },
            showBlueCircle: { type: Boolean, default: false },
        },

        computed: {
            inputClass() {
                return {
                    'form-input-switch': true,
                    'form-input-switch--blue-circle': this.showBlueCircle,
                    'form-input-switch--label-on-left': this.isLabelOnLeft,
                }
            },

            switchClass() {
                return {
                    'form-input-switch__switch': true,
                    'form-input-switch__switch--is-on': this.value,
                }
            },

            containerClass() {
                return {
                    [`form-input-switch__spacing--${this.spacing}`]: true,
                }
            },

            inlineIconClass() {
                return {
                    'form-input-switch__switch--icon-off': !this.value,
                    'form-input-switch__switch--icon-on': this.value,
                }
            },
        },
    }
</script>
